import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    contactInfo: [],
    isLoading: false,
    error: false,
    listingid: '',
};

const contactSlice = createSlice({
    name: 'contact',
    initialState,
    reducers: {
        contactrequest: (state) => {
            // console.log('contactrequest payload ', state);
            state.isLoading = true;
            state.error = false;
        },
        setContactinfo: (state, action) => {
            // console.log('contact payload ', action.payload);
            state.contactInfo = action.payload;
        },
        setContacterror: (state, action) => {
            // console.log('error payload ', action.payload);
            state.error = action.payload;
        },
        setListingid: (state, action) => {
            // console.log('error payload ', action.payload);
            state.listingid = action.payload;
        },
    },
});


export const { contactrequest, setContactinfo, setContacterror, setListingid } = contactSlice.actions;

export default contactSlice.reducer;